// @flow
import React, { useEffect, useState } from 'react';
import { EventTicketStatus } from 'Mock/eventTicketStatus';
import DotSeparator from 'components/atoms/dotSeparator';
import tableForOne from 'assets/images/Ticketing-Table-for-1.svg';
import tableForTwo from 'assets/images/Ticketing-Table-for-2-B.svg';
import tableForTwoCorner from 'assets/images/Ticketing-Table-for-2-A.svg';
import tableForThree from 'assets/images/Ticketing-Table-for-3.svg';
import tableForFour from 'assets/images/Ticketing-Table-for-4.svg';
import tableForFive from 'assets/images/Ticketing-Table-for-5.svg';
import tableForSix from 'assets/images/Ticketing-Table-for-6.svg';
import tableForSeven from 'assets/images/Ticketing-Table-for-7-8.svg';
import tableForEight from 'assets/images/Ticketing-Table-for-7-8.svg';
import { isEmpty } from 'lodash';
//eslint-disable-next-line
import styles from "./styles.scss";
type Props = {};

const areEqual = (prevProps, nextProps) => {
  return (
    prevProps.eventDate === nextProps.eventDate &&
    prevProps.personCount === nextProps.personCount &&
    prevProps.showFnB === nextProps.showFnB
  );
};

const EventTicketGrid = React.memo((props: Props) => {
  const { personCount, tableSelected, gridLayout, eventDate, showFnB, seating_ticket_price, onZoneSelect } = props;
  const [tableClick, setTableClick] = useState(false);

  const isHydLayout = gridLayout.sixthRow && gridLayout.seventhRow;

  useEffect(() => {
    let parent_div = document.getElementsByClassName(
      'ticket-grid-container'
    )[0];
    // to disable all the tables in the grid.
    let table_attributes = parent_div.getElementsByClassName('table-image');
    toggleTableClass('add', table_attributes, 'disabled');
    switch (personCount) {
      case 1:
        //single-seater tables are available only on the hyderabad layout.
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('single-table'),
          'disabled'
        );
        break;
      case 2:
        //if user selects person-count as 2, then enable the respective tables.
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-2'),
          'disabled'
        );
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-4'),
          'disabled'
        );
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('corner-table-1'),
          'disabled'
        );
        if(!isHydLayout){
          toggleTableClass(
            'remove',
            parent_div.getElementsByClassName('corner-table-2'),
            'disabled'
          );
        }
        toggleTableClass('remove', parent_div.getElementsByClassName('side-table'), 'disabled');
        break;
      case 3:
        //if user selects person-count as 3, then enable the respective tables.
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-1'),
          'disabled'
        );
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-5'),
          'disabled'
        );
        break;
      case 4:
        toggleTableClass('remove', parent_div.getElementsByClassName('corner-table-2'), 'disabled');
        break;
      case 5:
      case 6:
        //if user selects person-count as (4,5,6), then enable the respective tables.
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-1'),
          'disabled'
        );
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-5'),
          'disabled'
        );
        break;
      case 7:
      case 8:
        //if user selects person-count as (7,8), then enable the respective tables.
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-3'),
          'disabled'
        );
        break;
    }
  }, [personCount, tableClick]);

  useEffect(() => {
    let parent_div = document.getElementsByClassName(
      'ticket-grid-container'
    )[0];
    // to disable all the tables in the grid.
    let table_attributes = parent_div.getElementsByClassName('table-image');
    toggleTableClass('add', table_attributes, 'disabled');
  }, [eventDate]);

  const toggleTableClass = (type, attribute, className) => {
    // To add/remove a class from list of elements.
    for (let i = 0; i < attribute.length; i++) {
      if (type === 'remove') attribute[i].classList.remove(className);
      if (type === 'add') attribute[i].classList.add(className);
    }
  };
  const image_side_table =
    personCount === 5
      ? tableForFive
      : personCount === 6
      ? tableForSix
      : tableForThree;
  const image_centre_table = personCount === 7 ? tableForSeven : tableForEight;
 
  const minSeatingPrice = (Array.isArray(seating_ticket_price) && !isEmpty(seating_ticket_price)) 
    ? seating_ticket_price.reduce((sum, curr) => Math.min(sum, curr.price), +Infinity) : 0;
  
  const outletTableCol = (col_name, tables, zoneName, zonePrice, singleSeats = []) => (
    <div className={col_name}>
      {personCount === 5 || personCount === 6
        ? tableDiagram(
            tables[0],
            image_side_table,
            'joined-tables',
            [tables[0].id, tables[1].id],
            tables[0].booked || tables[1].booked
          )
        : tableDiagram(
            tables[0],
            image_side_table,
            '',
            [tables[0].id],
            tables[0].booked
          )}
      {personCount === 5 || personCount === 6
        ? null
        : tableDiagram(
            tables[1],
            tableForTwo,
            '',
            [tables[1].id],
            tables[1].booked
          )}
      {tableDiagram(
        tables[2],
        image_centre_table,
        '',
        [tables[2].id],
        tables[2].booked
      )}
      {minSeatingPrice && <div className="ticket-zones">
        <h4>{zoneName}</h4>
        <h4>₹ {zonePrice} /Guest</h4>
      </div>}
      {personCount === 5 || personCount === 6
        ? null
        : tableDiagram(
            tables[3],
            tableForTwo,
            '',
            [tables[3].id],
            tables[3].booked
          )}
      {personCount === 5 || personCount === 6
        ? tableDiagram(
            tables[4],
            image_side_table,
            'joined-tables',
            [tables[3].id, tables[4].id],
            tables[3].booked || tables[4].booked
          )
        : tableDiagram(
            tables[4],
            image_side_table,
            '',
            [tables[4].id],
            tables[4].booked
          )}
      {singleSeats.map(({ seat, slot }) => (
        <div key={seat.id} className={slot}>
          {tableDiagram(seat, tableForOne, '', [seat.id], seat.booked, 46)}
        </div>
      ))}
    </div>
  );
  const tableDiagram = (table, image, className, tableIds, isBooked, size = 50) => {
    //Used to form a Table Diagram and put all details of the respective tables.
    return (
      <img
        id={table.id}
        className={`${table.className} ${className} ${
          isBooked ? 'reserved' : ''
        }${table.imageSelected ? 'selected' : ''}`}
        src={image}
        alt={'table'}
        style={{ height: `${size}px`, width: `${size}px`, cursor: showFnB ? '' : 'pointer' }}
        onClick={showFnB ? undefined : () => onTableDiagramClick(table, tableIds)}
        aria-disabled={showFnB}
        tabIndex={showFnB ? -1 : 0}
      />
    );
  };
  const onTableDiagramClick = (tableData, tableIds) => {
    //Action triggered when user clicks on a table image,
    //Used to toggle the imageSelected boolean value from the data.
    let selectedZoneData = (Array.isArray(seating_ticket_price) && !isEmpty(seating_ticket_price)) 
      ? seating_ticket_price.find((zone) => zone.zone_id === tableData.zone_id) : null;
    if(!selectedZoneData) return;

    tableData.imageSelected = !tableData.imageSelected;
    toggleTableStatus(gridLayout.firstRow, tableData);
    toggleTableStatus(gridLayout.secondRow, tableData);
    toggleTableStatus(gridLayout.thirdRow, tableData);
    toggleTableStatus(gridLayout.fourthRow, tableData);
    toggleTableStatus(gridLayout.fifthRow, tableData);
    if (isHydLayout) {
      toggleTableStatus(gridLayout.sixthRow, tableData);
      toggleTableStatus(gridLayout.seventhRow, tableData);
      toggleTableStatus(gridLayout.sideTables, tableData);
      if (gridLayout.singleTables)
        toggleTableStatus(gridLayout.singleTables, tableData);
    }
    toggleTableStatus(gridLayout.cornerRow, tableData);
    tableData.imageSelected ? tableSelected(tableIds) : tableSelected([]);
    if (tableData.imageSelected && onZoneSelect) {
      let zoneName = selectedZoneData?.zone_name;
      let zonePrice = selectedZoneData?.price;
      if (zonePrice) onZoneSelect({ zoneName, zonePrice });
    } else if (onZoneSelect) {
      onZoneSelect(null);
    }
    setTableClick(!tableClick);
  };
  const toggleTableStatus = (rowData, specificTable) => {
    for (let i = 0; i < rowData.length; i++) {
      if (rowData[i].id !== specificTable.id) rowData[i].imageSelected = false;
    }
  };
  const getZoneDetails = (row) => {
    const zoneId = row[0]?.zone_id;
    const zoneData = (Array.isArray(seating_ticket_price) && !isEmpty(seating_ticket_price)) 
      ? seating_ticket_price.find((zone) => zone.zone_id === zoneId) : null;
    if(!zoneData) return;
    return {
      zoneName: zoneData?.zone_name,
      zonePrice: zoneData?.price
    }
  }
  
  const renderBlrLayout = () => (
    <>
      {gridLayout.cornerRow && gridLayout.cornerRow[0] && tableDiagram(
        gridLayout.cornerRow[0],
        tableForTwoCorner,
        '',
        [gridLayout.cornerRow[0].id],
        gridLayout.cornerRow[0].booked
      )}
      {gridLayout.cornerRow && gridLayout.cornerRow[1] && tableDiagram(
        gridLayout.cornerRow[1],
        tableForTwoCorner,
        '',
        [gridLayout.cornerRow[1].id],
        gridLayout.cornerRow[1].booked
      )}
      
      {outletTableCol(
        'table-col-1', 
        gridLayout.firstRow, 
        getZoneDetails(gridLayout.firstRow)?.zoneName, 
        getZoneDetails(gridLayout.firstRow)?.zonePrice
      )}
      {outletTableCol(
        'table-col-2', 
        gridLayout.secondRow, 
        getZoneDetails(gridLayout.secondRow)?.zoneName, 
        getZoneDetails(gridLayout.secondRow)?.zonePrice
      )}
      {outletTableCol(
        'table-col-3', 
        gridLayout.thirdRow, 
        getZoneDetails(gridLayout.thirdRow)?.zoneName, 
        getZoneDetails(gridLayout.thirdRow)?.zonePrice
      )}
      {outletTableCol(
        'table-col-4', 
        gridLayout.fourthRow, 
        getZoneDetails(gridLayout.fourthRow)?.zoneName, 
        getZoneDetails(gridLayout.fourthRow)?.zonePrice
      )}
      {outletTableCol(
        'table-col-5', 
        gridLayout.fifthRow, 
        getZoneDetails(gridLayout.fifthRow)?.zoneName, 
        getZoneDetails(gridLayout.fifthRow)?.zonePrice
      )}
    </>
  );


  const getSingleSeats = tableNumbers =>
    tableNumbers
      .map((num, idx) => ({
        seat: (gridLayout.singleTables || []).find(t => t.table_number === num),
        slot:
          tableNumbers.length === 1
            ? 'single-seat-middle'
            : idx === 0
            ? 'single-seat-top'
            : 'single-seat-bottom',
      }))
      .filter(item => item.seat);

  const renderHydLayout = () => (
    <>
      {gridLayout.cornerRow && gridLayout.cornerRow.map((cornerTable) => {
        if (cornerTable.table_number === 7) {
          return tableDiagram(
            cornerTable,
            tableForTwo,
            '',
            [cornerTable.id],
            cornerTable.booked
          );
        }
        if (cornerTable.table_number === 99) {
          return tableDiagram(
            cornerTable,
            tableForFour,
            '',
            [cornerTable.id],
            cornerTable.booked
          );
        }
        return null;
      })}
      
      
      {gridLayout.sideTables && gridLayout.sideTables.map((sideTable, idx) => (
        <div key={sideTable.id} className={`side-table-${idx + 1}`}>
          {tableDiagram(
            sideTable,
            tableForTwo,
            '',
            [sideTable.id],
            sideTable.booked
          )}
        </div>
      ))}
      
      {outletTableCol(
        'table-col-1', 
        gridLayout.firstRow, 
        getZoneDetails(gridLayout.firstRow)?.zoneName, 
        getZoneDetails(gridLayout.firstRow)?.zonePrice
      )}
      {outletTableCol(
        'table-col-2',
        gridLayout.secondRow,
        getZoneDetails(gridLayout.secondRow)?.zoneName,
        getZoneDetails(gridLayout.secondRow)?.zonePrice,
        getSingleSeats([98, 97])
      )}
      {outletTableCol(
        'table-col-3',
        gridLayout.thirdRow,
        getZoneDetails(gridLayout.thirdRow)?.zoneName,
        getZoneDetails(gridLayout.thirdRow)?.zonePrice,
        getSingleSeats([96, 95])
      )}
      {outletTableCol(
        'table-col-4',
        gridLayout.fourthRow,
        getZoneDetails(gridLayout.fourthRow)?.zoneName,
        getZoneDetails(gridLayout.fourthRow)?.zonePrice,
        getSingleSeats([94])
      )}
      {outletTableCol(
        'table-col-5',
        gridLayout.fifthRow,
        getZoneDetails(gridLayout.fifthRow)?.zoneName,
        getZoneDetails(gridLayout.fifthRow)?.zonePrice,
        getSingleSeats([93])
      )}
      {outletTableCol(
        'table-col-6',
        gridLayout.sixthRow,
        getZoneDetails(gridLayout.sixthRow)?.zoneName,
        getZoneDetails(gridLayout.sixthRow)?.zonePrice,
        getSingleSeats([92])
      )}
      {outletTableCol(
        'table-col-7',
        gridLayout.seventhRow,
        getZoneDetails(gridLayout.seventhRow)?.zoneName,
        getZoneDetails(gridLayout.seventhRow)?.zonePrice,
        getSingleSeats([91])
      )}
    </>
  );

  return (
    <div className={`ticket-grid-container ${isHydLayout ? 'hyd-layout' : 'blr-layout'}`}>
      <div className={'stage'}>
        <h3>STAGE</h3>
      </div>
      <div className={'status-types'}>
        {EventTicketStatus.map((status) => (
          <div key={status.label} className={` ${status.className} ticket-status`}>
            <DotSeparator />
            <span>{status.label}</span>
          </div>
        ))}
      </div>

      {isHydLayout ? renderHydLayout() : renderBlrLayout()}
    </div>
  );
}, areEqual);
export default EventTicketGrid;
